module.exports = __webpack_public_path__ + "00921b6f24642269213d0fd10405b9a8.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/torque-webfont/torque-light.woff
// module id = 84
// module chunks = 0